var initialTime = +new Date();
var requestAnimationFrame = window.requestAnimationFrame.bind(window) || function (fun) {
        return setTimeout(function () {
            fun.call(this, +new Date() - initialTime)
        }, 13);
    }

var cancelAnimationFrame = window.cancelAnimationFrame.bind(window) || clearInterval;

module.exports = {cancelAnimationFrame, requestAnimationFrame};


// WEBPACK FOOTER //
// ./js/caseconfigurator/polyfills/requestAnimationFrame.js